import Component from './_InViewport'
import elementResizeDetectorMaker from 'element-resize-detector'

export default class Footer extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            bg: null,
            inner: null,
        }
    }

    setRender() {
        if (window.innerWidth >= 1200) {
            this.render = function render(percent) {
                this.ref.inner.style.transform = `translate3d(0, ${ 100 - 100 * percent }px, 0)`
                this.ref.bg.style.transform = `translate3d(0, ${ 200 - 200 * percent }px, 0)`
            }
        } else {
            this.render = function () {}
        }

        const erd = elementResizeDetectorMaker({
            strategy: "scroll" //<- For ultra performance.
        })

        erd.listenTo(document.body, this.handleResize)

        document.addEventListener('swup:contentReplaced', event => this.resize())
        document.addEventListener('swup:animationOutDone', event => this.resize())
    }


}